import type reportOfflineId from "./id";

const reportOfflineEn: typeof reportOfflineId = {
	report_offline: {
		void: {
			title: "Void Transaction",
			description:
				"A voided transaction cannot be restored. Enter your PIN to continue.",
			pin: "User PIN",
			pin_required: "Please enter your PIN first.",
			notes: "Notes",
			confirm: "Void Transaction",
			cancel: "Close",
			success: "Transaction voided",
		},
		title: "Offline Store Report",
		subtitle: "Sales and finance summary",
		tabs: {
			summary: "Income Report",
			order: "Order",
			order_per_day: "Transaction Recap",
			order_per_product: "Sales Per Product",
			expenses: "Expenses",
		},
		filters: {
			store: "Store",
			all_stores: "All Stores",
			staff: "Staff",
			all_staff: "All Staff",
		},
		summary: {
			title: "Offline Store Report",
			subtitle: "Sales and finance summary",
			all_stores: "All Stores",
			loading_partner: "Loading partner info...",
			loading: "Loading...",
			empty: "No data",
			cards: {
				income: "Income",
				expense: "Expenses",
				summary: "Summary",
				receivable: "Receivables",
			},
			income: {
				cash: "Cash Payment",
				non_cash: "Non-Cash Payment",
				promo: "Promotions (Discount, Deduction, Cashback)",
				tax_received: "Tax Received",
				rounding: "Rounding",
				commission: "Commission",
				debt_payment: "Debt Payment",
				total: "Total Income",
			},
			expense: {
				cazhbox: "Balance (Cazhbox)",
				redeem_card: "Card Redemption",
				fee_mdr: "Fee (MDR)",
				expenses: "Costs (Expenses)",
				total: "Total Expenses",
			},
			totals: {
				net_income: "Net Income",
				hpp: "Cost of Goods Sold (COGS)",
				tax_liability: "Tax Liability",
				pnl: "Profit/Loss",
			},
			receivable: {
				total_given: "Total Given",
				remaining: "Outstanding Receivables",
			},
		},
		order_per_day: {
			title: "Sales Per Day Data",
			empty_state: {
				title: "No daily sales data",
				description: "No sales in this period.",
			},
			columns: {
				date: "Date",
				qty: "Sales Qty",
				total: "Total Sales",
			},
		},
		order_per_product: {
			title: "Sales Per Product",
			empty_state: {
				title: "No product sales data",
				description: "No product sales in this period.",
			},
			columns: {
				image: "Image",
				category: "Category",
				product: "Product",
				variant: "Variant",
				sold: "Sold",
				total: "Total",
				action: "Action",
			},
		},
		order: {
			title: "Order Data",
			empty_state: {
				title: "No order data",
				description: "No orders in this period.",
			},
			summary_stats: {
				qty: "Sales Qty",
				total: "Total Sales",
				order_unit: "orders",
			},
			columns: {
				order_id: "Order ID",
				date: "Date",
				sale_type: "Sale Type",
				payment_method: "Payment Method",
				customer: "Customer",
				store: "Store",
				staff: "Staff",
				total: "Total",
				status: "Status",
			},
			status: {
				not_settled: "Not Settled",
				settled: "Settled",
				canceled: "Canceled",
				success: "Success",
				pending: "Pending",
				failed: "Failed",
			},
		},
		expenses: {
			title: "Expense Data",
			empty_state: {
				title: "No expense data",
				description: "No expenses in this period.",
			},
			summary_stats: {
				qty: "Expense Qty",
				total: "Total Expenses",
				txn_unit: "transactions",
			},
			columns: {
				ref_id: "Ref ID",
				date: "Date",
				store: "Store",
				staff: "Staff",
				category: "Category",
				name: "Name",
				note: "Note",
				total: "Total",
				canceled_at: "Canceled At",
				canceled_by: "Canceled By",
				cancel_note: "Cancel Note",
				status: "Status",
			},
			status: {
				success: "Success",
				canceled: "Canceled",
			},
		},
		modals: {
			sales: {
				title: "Sales Detail",
				sections: {
					order_info: "Order Information",
					customer_store: "Customer & Store Information",
					payment: "Payment Information",
				},
				fields: {
					order_id: "Order ID",
					date: "Date",
					sale_type: "Sale Type",
					payment_method: "Payment Method",
					customer: "Customer",
					store: "Store",
					staff: "Staff",
					total_amount: "Total Amount",
					status: "Status",
				},
				close: "Close",
			},
			product: {
				title: "Product Sales Detail",
				sections: {
					product_info: "Product Information",
					sales_info: "Sales Information",
				},
				fields: {
					image: "Product Image",
					category: "Category",
					product_name: "Product Name",
					variant: "Variant",
					sold_qty: "Sold Quantity",
					total: "Total Sales",
				},
				unit: "Units",
				close: "Close",
			},
			customer: {
				title: "Customer Purchase Detail",
				sections: {
					customer_info: "Customer Information",
					purchase_info: "Purchase Information",
				},
				fields: {
					name: "Customer Name",
					phone: "Phone Number",
					email: "Email",
					total_transactions: "Total Transactions",
					total_amount: "Total Purchases",
				},
				txn_suffix: "Transactions",
				close: "Close",
			},
			payment: {
				title: "Payment Detail",
				sections: {
					payment_info: "Payment Information",
					customer_store: "Customer & Store Information",
				},
				fields: {
					date: "Date",
					ref_id: "RefID",
					total_payment: "Total Payment",
					status: "Status",
					customer: "Customer",
					store: "Store",
					staff: "Staff",
				},
				status: {
					success: "Success",
					canceled: "Canceled",
				},
				close: "Close",
			},
		},
	},
};

export default reportOfflineEn;
